import axios from '../Api/api';

export default async function logout() {
  await axios.post("profile/logout", {}, {
    headers: {
      Authorization: `Bearer ${localStorage.getItem('authToken')}`,
    }
  }
  )
    .then((res) => {
      if (res.status === 200) {
        localStorage.clear();
      }
      return res.status
    })
    .catch((res) => {
      throw new Error(res.response.data.message);
    })
}